export default __webpack_public_path__ + "images/cartoes-ico-hover.svg";